import Migration from './Migration';
import enhance from '../UpdateCustomerInfo/containers/UpdateCustomerInfoContainer';

export default enhance(Migration);



// WEBPACK FOOTER //
// ./src/app/membership/Migration/index.js